import Icon from '@components/utils/icons/icon';
import InternalLink from '@components/utils/links/internalLink';
import styled from '@emotion/styled';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { useFlow } from '@lib/pimster-flow/contexts/FlowContext';
import { Button } from '@lib/uikit';
import { hrefFromAs } from '@utils/link';
import { useRouter } from 'next/router';
import { FC } from 'react';

import { useFlowPage } from '../contexts/FlowPageContext';
import { getEscapeType } from '../utils/getters';

const RightAlign = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledIcon = styled(Icon)`
    cursor: pointer;
`;

export const FlowPageEscape: FC = () => {
    const { product, company } = useRouter().query;
    const { isEmbedContextLoading, isFlowBundle } = useEmbedContext();
    const { currentStep, totalSteps, onSkip, onExit } = useFlow();
    const { escapeText, flowPage, process } = useFlowPage();

    if (isEmbedContextLoading || typeof company !== 'string') return null;

    switch (
        getEscapeType({
            flowPage,
            flowCurrentStep: currentStep,
            flowTotalSteps: totalSteps,
            flowPageIsProcessing: process?.isLoading,
        })
    ) {
        case 'exit': {
            return (
                !isFlowBundle && (
                    <RightAlign>
                        <InternalLink
                            href={hrefFromAs(`/${product}`, company)}
                            linkAs={`/${product}`}
                            onClick={onExit}
                        >
                            <StyledIcon
                                name='close'
                                size='medium'
                                color='white'
                            />
                        </InternalLink>
                    </RightAlign>
                )
            );
        }

        case 'skip': {
            return (
                <RightAlign>
                    <Button
                        colorScheme='white'
                        variant='underline'
                        onClick={onSkip}
                    >
                        {escapeText}
                    </Button>
                </RightAlign>
            );
        }

        default:
            return null;
    }
};
